var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 101,
    viewBox: "0 0 89 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.3012 0.341309L80.3126 90.331L44.4031 100.341L8.59257 90.3448L0.612183 0.341309H88.3012Z",
    fill: "#E44D26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4564 92.6896L73.4731 84.6007L80.2996 7.7002H44.4564V92.6896Z",
    fill: "#F16529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9268 29.7773H44.4565V18.7388H16.9296L17.1922 21.7002L19.8905 52.1196H44.4565V41.081H29.9301L28.9268 29.7773ZM31.4009 57.639H20.381L21.9188 74.9713L44.406 81.248L44.4565 81.2342V69.7494L44.4084 69.7622L32.1826 66.4427L31.4009 57.639Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4186 52.1196H57.9364L56.6619 66.4358L44.4182 69.7587V81.2428L66.9233 74.9713L67.0883 73.1062L69.6683 44.0452L69.9361 41.081H44.4186V52.1196ZM44.4186 29.7504V29.7773H70.9349L71.1549 27.2964L71.6554 21.7002L71.9177 18.7388H44.4186V29.7504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/HTML.bea65f745fa55640ec416fc6fd623d05.svg";
export { ForwardRef as ReactComponent };